var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRooftops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 32V1H32V32H1Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8195 13.975H3.17922C2.79627 13.975 2.48584 14.2854 2.48584 14.6684V15.5195C2.48584 15.9024 2.79627 16.2128 3.17922 16.2128H29.8195C30.2023 16.2128 30.5127 15.9024 30.5127 15.5195V14.6684C30.5127 14.2854 30.2023 13.975 29.8195 13.975Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89987 6.51681C8.77048 6.51681 9.47624 5.81104 9.47624 4.94043C9.47624 4.06982 8.77048 3.36406 7.89987 3.36406C7.02926 3.36406 6.32349 4.06982 6.32349 4.94043C6.32349 5.81104 7.02926 6.51681 7.89987 6.51681Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89844 1.56081V0.96875",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89844 8.91236V8.32031",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50456 2.55072L5.08594 2.13203",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7046 7.7491L10.2859 7.33047",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5154 4.94063H3.92334",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8655 4.94063H11.2734",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50456 7.33047L5.08594 7.7491",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7046 2.13203L10.2859 2.55072",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.761 8.96484V13.9127",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.761 11.5984H20.3859V13.9126",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0984 8.96484V13.9127",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0983 11.5984H24.4734V13.9126",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4485 9.98125H24.4067",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4358 10.243V13.9126",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4358 9.89168V6.06876",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4358 2.61094V1.67343",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7885 5.48593C26.0255 3.84572 24.3631 2.70859 22.4349 2.70859C20.5068 2.70859 18.8445 3.84572 18.0815 5.48593C17.9725 5.72017 18.1455 5.98824 18.4037 5.98824H26.4661C26.7245 5.98824 26.8975 5.72017 26.7885 5.48593Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7234 5.98822H24.1411C23.9026 4.08252 23.2277 2.70859 22.4323 2.70859C21.637 2.70859 20.9619 4.08252 20.7234 5.98822Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16089 24.3453V24.8297",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2051 19.3821H6.9166C6.61654 19.3821 6.37329 19.6253 6.37329 19.9253V29.7939H10.7483V19.9253C10.7484 19.6253 10.5051 19.3821 10.2051 19.3821Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.407 19.3821H13.2167C12.9166 19.3821 12.6733 19.6253 12.6733 19.9253V25.4456C12.6733 25.7458 12.9166 25.989 13.2167 25.989H15.407C15.7071 25.989 15.9503 25.7458 15.9503 25.4456V19.9253C15.9503 19.6253 15.7071 19.3821 15.407 19.3821Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7447 19.3821H18.5543C18.2542 19.3821 18.011 19.6253 18.011 19.9253V25.4456C18.011 25.7458 18.2542 25.989 18.5543 25.989H20.7447C21.0447 25.989 21.2879 25.7458 21.2879 25.4456V19.9253C21.2879 19.6253 21.0447 19.3821 20.7447 19.3821Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0821 19.3821H23.8917C23.5917 19.3821 23.3484 19.6253 23.3484 19.9253V25.4456C23.3484 25.7458 23.5917 25.989 23.8917 25.989H26.0821C26.3821 25.989 26.6255 25.7458 26.6255 25.4456V19.9253C26.6255 19.6253 26.3821 19.3821 26.0821 19.3821Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9983 22.6851H15.6233",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3235 22.6851H20.9329",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6733 22.6851H26.3191",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 32.0315H31.3425C31.7254 32.0315 32.0358 31.7211 32.0358 31.3382V30.4872C32.0358 30.1041 31.7254 29.7937 31.3425 29.7937H1.66677C1.28383 29.7937 0.973389 30.1041 0.973389 30.4872V31.3382C0.973389 31.7211 1.28383 32.0315 1.66677 32.0315H15.4109",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9723 21.5917V16.2133H4.03589V29.7938H28.9723V23.7792",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooftops);
export default __webpack_public_path__ + "static/media/rooftops.9b8fa75a82a5b08ae0bf01dc8d87c255.svg";
export { ForwardRef as ReactComponent };